import { createSlice } from '@reduxjs/toolkit';

const TYPES = [
  {
    id: 0,
    type: 'integration',
    title: 'Integrations',
  },
  {
    id: 1,
    type: 'file',
    title: 'Files',
  },
  {
    id: 2,
    type: 'faq',
    title: 'FAQ',
  },
  {
    id: 3,
    type: 'website',
    title: 'Websites',
  },
];

const initialState = {
  types: TYPES,
  filteredTypes: TYPES,
};

export const knowledgeBaseSlices = createSlice({
  name: 'knowledgeBaseSlices',
  initialState: { ...initialState },
  reducers: {
    setFilteredTypes(state, action) {
      const { types } = action.payload;

      state.filteredTypes = types;
    },
    resetFilteredTypes(state) {
      state.filteredTypes = [...initialState.types];
    },
  },
});

export const { setFilteredTypes, resetFilteredTypes } = knowledgeBaseSlices.actions;

export default knowledgeBaseSlices.reducer;
